import React, { FC, useRef } from 'react';
import Avatar from '#components/common/avatar/Avatar';
import s from '#components/blocks/userName/userName.module.scss';

type Props = {
  title?: string;
  placeholder?: string;
  avatarAssetId?: number;
  value: string;
  onChangeName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
};

const UserName: FC<Props> = ({
  placeholder,
  avatarAssetId,
  value,
  onChangeName,
  onKeyPress,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div>
      <div className="tw-max-w-lg tw-mx-auto">
        <Avatar avatarAssetId={avatarAssetId} extraClass="tw-mb-4" />
        <div className={s.name}>
          <input
            ref={inputRef}
            className={s.input}
            data-testid="profile-username-input"
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={onChangeName}
            onKeyPress={onKeyPress}
            onClick={handleClick}
            maxLength={25}
            /* eslint-disable-next-line jsx-a11y/no-autofocus */
            autoFocus={true}
          />
        </div>
      </div>
    </div>
  );
};

export default UserName;
